import React from "react";

type LineBreakTextProps = {
  value?: string | null;
  className?: string;
};

export const LineBreakText = ({ value, className }: LineBreakTextProps) => {
  if (!value || typeof value !== "string") {
    return value ? <span className={className}>{value}</span> : null;
    }

  const segments = value.split(/<br\s*\/?>(?:\s*)/gi);

  return (
    <span className={className}>
      {segments.map((segment, index) => (
        <React.Fragment key={`segment-${index}`}>
          {segment}
          {index < segments.length - 1 && <br />}
        </React.Fragment>
      ))}
    </span>
  );
};

